<template>
  <div v-if="animal" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes do Animal</h4>
      <router-link to="/cadastros/animais">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="">
        <p><strong>Nome:</strong> {{ animal.nome || 'Não informado' }}</p>
        <p>
          <strong>Proprietário:</strong>
          <span v-if="animal.proprietario_nome_pessoa_fisica">
            {{ animal.proprietario_nome_pessoa_fisica }}
          </span>
          <span v-else-if="animal.proprietario_nome_pessoa_juridica">
            {{ animal.proprietario_nome_pessoa_juridica }}
          </span>
          <span v-else>
            Não informado
          </span>
        </p>
        <p><strong>Ativo:</strong> {{ utils.verificarAtivo(animal?.ativo) }}</p>
      </FormSection>

      <FormSection title="">
        <p><strong>Sexo:</strong> {{ animal.sexo || 'Não informado' }}</p>
        <p><strong>Raça:</strong> {{ animal.raca || 'Não informado' }}</p>
        <p><strong>Data de Nascimento:</strong> {{ utils.formatarData(animal.nascimento) }}</p>
        <p><strong>Data de Entrada:</strong> {{ utils.formatarData(animal.data_entrada) }}</p>
      </FormSection>

      <FormSection title="">
        <p><strong>Observações:</strong> {{ animal.observacao || 'Nenhuma' }}</p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";
import globalUtils from "@/utils/globalUtils.js";

export default {
  components: { FormSection },
  data() {
    return {
      animal: null,
    };
  },
  computed: {
    utils() {
      return globalUtils;
    },
  },
  methods: {
    async carregarDetalhesAnimal() {
      try {
        const response = await axios.get(
          `/cadastros/animais/${this.$route.params.id}`
        );
        // A resposta já deverá conter os campos proprietario_nome_pessoa_fisica ou proprietario_nome_pessoa_juridica
        this.animal = response.data;
      } catch (error) {
        console.error("Erro ao carregar os detalhes do animal:", error);
      }
    },
  },
  mounted() {
    this.carregarDetalhesAnimal();
  },
};
</script>

<style scoped>
.card {
  max-width: 1000px;
  margin: 0 auto;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}

.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}

.form-content {
  margin-top: 1.5rem;
}

button.btn-sm {
  padding: 6px 12px;
}
</style>
